import { Map } from 'immutable';
import { REHYDRATE } from 'redux-persist/constants'
import { LOGIN_USER, LOGOUT_USER, GET_USER } from '../actions/auth';


const initialState = Map({
  user: {}
});

const actionsMap = {
  [LOGIN_USER]: (state, action) => {
    return state.set('user', action.user);
  },
  [LOGOUT_USER]: (state) => {
    return state.set('user', {});
  },
  [GET_USER]: (state) => {
    return state.get('user');
  },
  [REHYDRATE]: (state, action) => {
    var incoming = action.payload.auth;
    if (incoming) return state.set('user', incoming.user);
    return state;
  }
};

export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}


// WEBPACK FOOTER //
// ./reducers/auth.js